import { render, staticRenderFns } from "./ComVideo.vue?vue&type=template&id=15bc095e&"
import script from "./ComVideo.vue?vue&type=script&lang=js&"
export * from "./ComVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports